import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NotificationOffIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NotificationOff",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.53 18.24v-7.56c-.02-4.22-3.45-7.63-7.67-7.61A7.6 7.6 0 0 0 9.65 6.3zM8.25 13.36v5.93l-3.49 3.06a.987.987 0 0 0 0 1.41c.17.18.4.28.65.3H20.7L8.26 13.36Zm7.56 15.57c1.61 0 2.92-1.32 2.92-2.93H12.9c0 1.61 1.3 2.92 2.91 2.93m13.26-.49c.41-.02.8-.22 1.06-.54.52-.65.42-1.59-.23-2.11L4.06 3.58A1.5 1.5 0 0 0 2 5.76c.05.05.11.09.17.13L28.02 28.1c.29.24.67.36 1.05.33Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19 30.57h-6.86a1.14 1.14 0 1 1 0-2.28H19a1.14 1.14 0 1 1 0 2.28M20.14 26H3c-.53 0-.99-.36-1.11-.88s.13-1.05.6-1.29c1.85-.93 2.8-1.91 2.8-4.69v-8a1.14 1.14 0 1 1 2.28 0v8c0 1.93-.39 3.4-1.28 4.57h13.85a1.14 1.14 0 1 1 0 2.28ZM24.71 19.14c-.63 0-1.14-.51-1.14-1.14v-6.86c0-4.41-3.59-8-8-8-1.41 0-2.8.37-4.01 1.08-.55.32-1.25.13-1.56-.41-.32-.55-.13-1.25.41-1.56 1.56-.91 3.34-1.39 5.16-1.39 5.67 0 10.29 4.61 10.29 10.29v6.86c0 .63-.51 1.14-1.14 1.14ZM28.14 28.29c-.29 0-.58-.11-.81-.33L2.19 2.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95Z"
      })
    })
  }));
};
NotificationOffIcon.displayName = 'NotificationOffIcon';